
import { Item } from '@/types/item'
import { ItemType } from '@/types/itemType'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import dayjs from 'dayjs'
import { computed, defineComponent, onMounted, onUnmounted, reactive, Ref, ref, watch } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'HomeView',
  components: {
    Datepicker
  },
  setup() {
    const store = useStore()
    const calendarDate: Ref<Date> = ref<Date>(new Date())
    const newItem = ref({
      date: '',
      type: '',
      price: null,
      name: '',
      weight: null
    } as Item)

    const handleDate = async (modelDate: Date) => {
      calendarDate.value = modelDate
    }

    onMounted(() => {
      store.dispatch('itemStore/subscribeItems', calendarDate.value)
      store.dispatch('itemTypeStore/subscribeItemTypes')
    })

    watch(calendarDate, () => {
      store.dispatch('itemStore/subscribeItems', calendarDate.value)
    })

    const items = computed<Item[]>(() => store.state.itemStore.items)
    const itemTypes = computed<ItemType[]>(() => store.state.itemTypeStore.itemTypes)

    const onDeleteItem = (id: string) => {
      const item = items.value.find((i: any) => i.id === id)
      if (!confirm(`ยืนยันการลบสินค้า: ${item?.name || ''}`)) return
      store.dispatch('itemStore/deleteItem', id)
    }

    const onSubmitItem = async () => {
      await store.dispatch('itemStore/addItem', {
        ...newItem.value,
        date: dayjs(calendarDate.value).format('DD-MM-YYYY')
      })

      newItem.value = {} as Item
    }

    const sumItemPrice = computed(() => items.value.map(item => item.price).reduce((prev, curr) => ((Number(prev) || 0) + (Number(curr) || 0)), 0))

    return {
      items,
      newItem,
      sumItemPrice,
      calendarDate,
      itemTypes,
      handleDate,
      onDeleteItem,
      onSubmitItem
    }
  }
})
